export default __webpack_public_path__ + "static/media/cotidiano-horizontal.03f059e6.svg";